import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../../../hooks/useSEO';

export default function TaichungPage() {
  useSEO({
    title: '台中搬家公司推薦｜專業搬家服務｜台中市搬家費用估價',
    description: '台中搬家公司推薦！提供台中市西屯區、南屯區、北屯區、豐原區等29區專業搬家服務。24小時服務、免費估價、專業團隊、價格透明。台中搬家找安心搬家，讓您搬家無煩惱！',
    keywords: '台中搬家,台中搬家公司,西屯區搬家,南屯區搬家,北屯區搬家,豐原區搬家,台中搬家費用,台中搬家推薦,台中市搬家,台中搬家估價',
    ogImage: 'https://public.readdy.ai/ai/img_res/d10c1332c3531e2da3538b9b7fb682e1.jpg'
  });

  useEffect(() => {
    // Schema.org LocalBusiness 結構化資料
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "安心搬家 - 台中搬家服務",
      "image": "https://readdy.ai/api/search-image?query=professional%20moving%20service%20team%20carefully%20loading%20furniture%20and%20boxes%20into%20a%20modern%20moving%20truck%20in%20Taichung%20city%20Taiwan%2C%20bright%20daylight%2C%20clean%20urban%20residential%20area%20with%20modern%20buildings%2C%20workers%20wearing%20safety%20vests%20and%20gloves%2C%20organized%20and%20efficient%20moving%20process%2C%20high%20quality%20professional%20photography%2C%20realistic%20scene&width=1200&height=630&seq=taichung-moving-og-001&orientation=landscape",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "台中市西屯區",
        "addressLocality": "台中市",
        "addressRegion": "台中市",
        "postalCode": "407",
        "addressCountry": "TW"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 24.1477,
        "longitude": 120.6736
      },
      "telephone": "+886-800-888-888",
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      },
      "priceRange": "$$",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "189"
      },
      "areaServed": [
        { "@type": "City", "name": "中區" },
        { "@type": "City", "name": "東區" },
        { "@type": "City", "name": "南區" },
        { "@type": "City", "name": "西區" },
        { "@type": "City", "name": "北區" },
        { "@type": "City", "name": "西屯區" },
        { "@type": "City", "name": "南屯區" },
        { "@type": "City", "name": "北屯區" },
        { "@type": "City", "name": "豐原區" },
        { "@type": "City", "name": "大里區" },
        { "@type": "City", "name": "太平區" },
        { "@type": "City", "name": "清水區" },
        { "@type": "City", "name": "沙鹿區" },
        { "@type": "City", "name": "大甲區" },
        { "@type": "City", "name": "東勢區" },
        { "@type": "City", "name": "梧棲區" },
        { "@type": "City", "name": "烏日區" },
        { "@type": "City", "name": "神岡區" },
        { "@type": "City", "name": "大肚區" },
        { "@type": "City", "name": "大雅區" },
        { "@type": "City", "name": "后里區" },
        { "@type": "City", "name": "霧峰區" },
        { "@type": "City", "name": "潭子區" },
        { "@type": "City", "name": "龍井區" },
        { "@type": "City", "name": "外埔區" },
        { "@type": "City", "name": "和平區" },
        { "@type": "City", "name": "石岡區" },
        { "@type": "City", "name": "新社區" },
        { "@type": "City", "name": "大安區" }
      ]
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const taichungDistricts = [
    { name: '西屯區', features: ['逢甲商圈', '中科園區', '新光三越'] },
    { name: '南屯區', features: ['精密機械園區', '豐樂雕塑公園', '黎明新村'] },
    { name: '北屯區', features: ['太原車站', '一點利市場', '民俗公園'] },
    { name: '西區', features: ['台中火車站', '第五市場', '美術館'] },
    { name: '北區', features: ['中友百貨', '台中公園', '一中商圈'] },
    { name: '東區', features: ['台中糖廠', '旱溪夜市', '樂成宮'] },
    { name: '南區', features: ['中興大學', '文心森林公園', '德安百貨'] },
    { name: '中區', features: ['台中州廳', '柳川藍帶水岸', '宮原眼科'] },
    { name: '豐原區', features: ['豐原火車站', '廟東夜市', '葫蘆墩文化中心'] },
    { name: '大里區', features: ['大里運動公園', '草湖溪', '仁愛醫院'] },
    { name: '太平區', features: ['新光國小', '坪林森林公園', '太平買菸場'] },
    { name: '東勢區', features: ['東勢林場', '客家文化園區', '軟埤坑休閒農業區'] }
  ];

  const services = [
    {
      icon: 'ri-building-line',
      title: '學生宿舍搬遷',
      description: '逢甲、東海、中興等大學周邊專業搬遷'
    },
    {
      icon: 'ri-home-4-line',
      title: '透天厝搬家',
      description: '台中特色透天厝結構熟悉，樓梯搬運專業'
    },
    {
      icon: 'ri-community-line',
      title: '社區大樓搬遷',
      description: '電梯大樓、老舊公寓皆有豐富經驗'
    },
    {
      icon: 'ri-truck-line',
      title: '中科園區搬遷',
      description: '科學園區廠辦搬遷，設備搬運專業認證'
    }
  ];

  const faqData = [
    {
      question: '台中搬家公司推薦哪一家？',
      answer: '建鈞精緻搬家深耕台中 29 區搬家服務，熟悉逢甲商圈、中科園區、各大學城區域特色。我們擁有 4.8 分高評價和 156 則客戶好評，提供學生搬遷、透天厝搬家、科學園區廠辦搬遷專業服務，是台中在地居民推薦的搬家公司。'
    },
    {
      question: '台中搬家費用怎麼算？',
      answer: '台中地區搬家費用：套房搬遷 3,000 元起（雙邊電梯優惠價），家庭搬遷 3,000-8,000 元，辦公室搬遷 5,000-20,000 元。透天厝搬家依樓層和物品數量計價。我們提供免費現場估價服務，確保報價準確透明。'
    },
    {
      question: '台中搬家當天可以預約嗎？',
      answer: '建議提前 3-7 天預約，讓我們安排專業團隊和車輛。逢甲商圈、一中商圈等熱門區域建議提前 1-2 週預約。學生搬家旺季（6-8月、寒暑假）建議提前預約。急件可來電 0978-900-081 詢問。'
    },
    {
      question: '台中透天厝搬家要注意什麼？',
      answer: '台中透天厝搬家需注意：1. 樓梯搬運需更多人力（建議 3-4 位師傅）；2. 大型家具可能需要吊車協助；3. 巷弄較窄需確認車輛通行；4. 鄰居溝通避免影響通行。我們團隊經驗豐富，熟悉台中透天厝結構特色。'
    },
    {
      question: '台中學生搬家有優惠嗎？',
      answer: '我們提供學生搬家優惠方案！逢甲、東海、中興等大學周邊學生搬家，套房搬遷 2,500 元起。提供學生證可享額外折扣。我們熟悉各大學周邊租屋環境，提供快速、經濟的學生搬家服務。'
    },
    {
      question: '台中搬家什麼時間最便宜？',
      answer: '平日（週一至週五）和非月底時段價格較優惠。避開學生搬家旺季（6-8月、寒暑假）和週末，可享有更好的價格。我們也提供夜間搬家服務，配合您的時間需求，歡迎來電詢問優惠方案。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Taichung%20city%20modern%20urban%20landscape%20with%20residential%20areas%20and%20commercial%20districts%2C%20vibrant%20cityscape%20with%20organized%20neighborhoods%20and%20clear%20blue%20sky%2C%20professional%20moving%20services%20concept&width=1920&height=500&seq=taichung001&orientation=landscape"
            alt="台中搬家服務"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-5xl font-bold mb-6">台中搬家公司推薦</h1>
          <p className="text-xl mb-8 leading-relaxed">
            深耕台中29區搬家服務，熟悉逢甲商圈、中科園區、各大學城區域特色<br />
            提供學生搬遷、透天厝搬家、科學園區廠辦搬遷專業服務
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:0978900081" 
              className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-phone-line mr-2"></i>
              立即致電：0978-900-081
            </a>
            <a 
              href="https://line.me/ti/p/@285yavdh" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-line-fill mr-2"></i>
              官方LINE
            </a>
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">台中市 29 區完整服務</h2>
            <p className="text-xl text-gray-600">熟悉台中各區域特色，提供在地化專業搬家服務</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {taichungDistricts.map((district, index) => (
              <div key={index} className="bg-gradient-to-br from-teal-50 to-white border border-teal-200 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <h3 className="font-bold text-lg text-gray-900 mb-3 flex items-center">
                  <i className="ri-map-2-line text-teal-600 mr-2"></i>
                  {district.name}
                </h3>
                <div className="space-y-1">
                  {district.features.map((feature, idx) => (
                    <div key={idx} className="text-sm text-gray-600 flex items-center">
                      <i className="ri-checkbox-circle-line text-teal-500 mr-2 text-xs"></i>
                      {feature}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Specialized Services */}
      <section className="py-20 px-4 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">台中在地特色服務</h2>
            <p className="text-xl text-gray-600">針對台中地區特色需求，提供客製化搬家解決方案</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border border-gray-200 hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Local Advantages */}
      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">台中在地服務優勢</h2>
            <p className="text-xl text-gray-600">深度瞭解台中生活特色，提供最貼心的搬家服務</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-teal-50 to-white rounded-xl p-6 border border-teal-100">
              <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-road-map-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">熟悉台中路況</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                深知台中市區道路、巷弄限制，避開尖峰時段壅塞路段，確保搬家時程準確
              </p>
            </div>

            <div className="bg-gradient-to-br from-cyan-50 to-white rounded-xl p-6 border border-cyan-100">
              <div className="w-12 h-12 bg-cyan-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-graduation-cap-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">學生搬遷專業</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                熟悉各大學周邊租屋環境，提供學生族群經濟實惠的搬家方案
              </p>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-white rounded-xl p-6 border border-emerald-100">
              <div className="w-12 h-12 bg-emerald-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-building-2-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">透天厝搬遷</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                台中透天厝結構特色熟悉，樓梯搬運、空間規劃都有豐富經驗
              </p>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-white rounded-xl p-6 border border-green-100">
              <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-cpu-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">中科園區合作</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                與中部科學園區廠商長期合作，熟悉科技業搬遷需求與標準
              </p>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-white rounded-xl p-6 border border-teal-100">
              <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-time-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">彈性服務時間</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                配合台中生活步調，提供假日、夜間搬家服務，滿足不同需求
              </p>
            </div>

            <div className="bg-gradient-to-br from-cyan-50 to-white rounded-xl p-6 border border-cyan-100">
              <div className="w-12 h-12 bg-cyan-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">在地口碑保證</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                深耕台中多年，累積優良口碑，客戶推薦率高達 95% 以上
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 台中搬家常見問題（口語化） */}
      <section className="py-20 px-4 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">台中搬家常見問題</h2>
            <p className="text-xl text-gray-600">最多人問的台中搬家問題，一次解答</p>
          </div>

          <div className="space-y-6">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border border-gray-200 hover:shadow-lg transition-shadow">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                  <i className="ri-question-line text-teal-500"></i>
                  {faq.question}
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <Link 
              to="/faq" 
              className="inline-block bg-teal-500 hover:bg-teal-600 text-white px-8 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              查看更多常見問題
            </Link>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-20 px-4 bg-gradient-to-br from-teal-500 to-teal-600">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl font-bold mb-6">準備在台中搬家嗎？</h2>
          <p className="text-xl mb-8 leading-relaxed">
            立即聯繫我們，獲得專業的台中搬家服務評估<br />
            熟悉台中各區特色，提供最貼心的在地服務
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:0978900081"
              className="bg-white hover:bg-gray-100 text-teal-600 px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-phone-line mr-2"></i>
              電話諮詢：0978-900-081
            </a>
            <a 
              href="https://line.me/ti/p/@285yavdh" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-teal-700 hover:bg-teal-800 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-line-fill mr-2"></i>
              官方LINE
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
